<template>
    <div class="container">
        <div class="mian-content">
            <div class="left-box">
                <div class="top-logo">
                    <img src="../assets/img/logo.png">
                </div>
                <div class="form">
                    <form action="#">
                        <div class="form-item">
                            <div class="form-input">
                                <input type="text" placeholder="请输入你的手机号" v-model="ruleForm.phone" @blur="checkPhone">
                            </div>
                            <div class="err-message">
                                <el-alert :title="errorMessage.phone" type="warning" show-icon :closable="false"
                                    v-if="showMessage.phone" />
                            </div>
                        </div>
                        <div class="form-item" v-if="loginType === 'mm'">
                            <div class="form-input">
                                <input type="password" placeholder="请输入密码" v-model="ruleForm.password"
                                    @blur="checkPassWord">
                            </div>
                            <div class="err-message">
                                <el-alert :title="errorMessage.password" type="warning" show-icon :closable="false"
                                    v-if="showMessage.password" />
                            </div>
                        </div>
                        <div class="form-item" v-if="loginType === 'yzm'">
                            <div class="form-input-code">
                                <input type="text" placeholder="请输入验证码" v-model="ruleForm.code" @blur="checkCode">
                                <button @click="getCode" :disabled="disabled" type="button">
                                    <span v-if="isShow">验证码</span>
                                    <span v-else>{{ timeValue }}s获取</span>
                                </button>
                            </div>
                            <div class="err-message">
                                <el-alert :title="errorMessage.code" type="warning" show-icon :closable="false"
                                    v-if="showMessage.code" />
                            </div>
                        </div>
                    </form>
                </div>
                <div class="login" @click="submitForm">
                    <button type="button">登录</button>
                </div>
                <div class="login-tip">
                    <div style="display: flex; justify-content: space-between; width: 100%;">
                        <span>温馨提示：如遇初始密码、密码异常或权限问题，请联系小宝老师处理。</span>
                        <span @click="handleForgetPwd" style="color: #00C667; cursor: pointer; flex-shrink: 0; margin-left: 10px;">忘记密码？</span>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <img src="../assets/img/back-logo.png">
            </div>
        </div>
        <div class="flie-ror-record">
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">贵州旺黔诚教育科技有限公司 黔ICP备2022009207号-1</a>
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">贵公网安备52010202004269号</a>
        </div>
    </div>
</template>

<script>
//引入请求
import customFetch from '../utils/request'
export default {
    data() {
        return {
            errorMessage: {
                phone: "",
                code: "",
                password: ""
            },
            showMessage: {
                phone: false,
                code: false,
                password: false
            },
            ruleForm: {
                phone: "",
                code: "",
                password: ""
            },
            isShow: true,
            timer: 0,
            timeValue: 60,
            disabled: false,
            codeValue: '',
            loginType: 'mm'
        }
    },
    methods: {
        checkPhone() {
            const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
            if (this.ruleForm.phone === '') {
                this.showMessage.phone = true
                this.errorMessage.phone = '手机号不能为空'
            } else if (!regPhone.test(this.ruleForm.phone)) {
                this.showMessage.phone = true
                this.errorMessage.phone = '手机号格式不对'
            } else {
                this.showMessage.phone = false
                return true
            }
        },
        checkPassWord() {
            console.log(111)
            if (this.ruleForm.password == '') {
                this.showMessage.password = true
                this.errorMessage.password = '密码不能为空'
                console.log(this.errorMessage.password, '密码不能为空')
            } else {
                this.showMessage.password = false
                return true
            }
        },
        checkCode() {
            if (this.ruleForm.code == '') {
                this.showMessage.code = true
                this.errorMessage.code = '验证码不能为空'
            } else {
                this.showMessage.code = false
                return true
            }
        },
        //获取验证码
        getCode() {
            if (this.ruleForm.phone === '') {
                return this.$message.error('手机号不能为空');
            }
            customFetch(`/sendCode?phone=${this.ruleForm.phone}`).then(res => {
                if (res.code === '200') {
                    this.$message.success('验证码已发送，请注意查收');
                    this.codeValue = res.data
                    this.getTimer()
                }
            }).catch((error) => { console.log(error) })
        },
        //登录
        submitForm() {
            const params = {
                phone: this.ruleForm.phone,
                code: this.ruleForm.code,
                password: this.ruleForm.password
            }
            if (this.loginType === 'mm') {
                if (!this.checkPhone() || !this.checkPassWord()) return
                customFetch(`/userPermittion/login_pwd`,{
                   body:JSON.stringify(params),
                }).then(res => {
                    if (String(res.code) === '200') {
                        localStorage.setItem('token', JSON.stringify(res.data || {}))
                        this.$router.push({
                            path: "/"
                        })
                        this.$message.success('登录成功')
                    } else {
                        const message = res.msg || '密码错误'
                        this.showMessage.password = true
                        this.errorMessage.password = message
                        this.$message.error(message)
                    }
                }).catch((error) => { console.log(error) })
            } else if (this.loginType === 'yzm') {
                if (!this.checkPhone() || !this.checkCode()) return
                customFetch(`/userPermittion/login?phone=${params.phone}&code=${params.code}`).then(res => {
                    if (String(res.code) === '200') {
                        localStorage.setItem('token', JSON.stringify(res.data || {}))
                        this.$router.push({
                            path: "/"
                        })
                        this.$message.success('登录成功')
                    } else {
                        const message = res.msg || '验证码错误'
                        this.showMessage.code = true
                        this.errorMessage.code = message
                        this.$message.error(message)
                    }
                }).catch((error) => { console.log(error) })
            }
        },
        //验证码倒计时
        getTimer() {
            console.log(111)
            this.disabled = true
            this.isShow = false
            this.timer = setInterval(() => {
                if (this.timeValue < 1) {
                    clearInterval(this.timer)
                    this.timeValue = 60
                    this.disabled = false
                    this.isShow = true
                }
                this.timeValue--
            }, 1000)
        },
        handleForgetPwd() {
            this.$alert('请联系小宝老师，在"上传视频/进入直播间权限"中为您重置密码', '忘记密码', {
                confirmButtonText: '确定',
                type: 'info'
            });
        }
    }
}
</script>


<style scoped lang="scss">
button {
    border-radius: 8px;
    border: 1px solid transparent;
    padding: 0.6em 1.2em;
    font-size: 1em;
    font-weight: 500;
    font-family: inherit;
    background-color: #1a1a1a;
    cursor: pointer;
    transition: border-color 0.25s;
}

input[type=text]:focus {
    outline: none;
}

input[type=password]:focus {
    outline: none;
}

input {
    border: none;
}

.container {
    height: 100vh;
    background: #2A3342;
    display: flex;
    justify-content: center;
    align-items: center;

    .mian-content {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        background: #ffffff;

        .right-box {
            height: 359px;
            width: 300px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .left-box {
            padding: 0 20px;
            padding-bottom: 20px;

            .top-logo {
                margin-top: -20px;
                display: flex;
                justify-content: center;

                img {
                    width: 48px;
                }
            }

            .login {
                button {
                    width: 100%;
                    display: block;
                    background: #00C667;
                    color: #ffffff;
                }
            }

            .login-tip {
                margin-top: 8px;
                font-size: 12px;
                line-height: 1.5;
                color: #909399;
                max-width: 320px;
                width: 100%;
            }

            .form {
                padding-top: 20px;

                .form-item {

                    .form-input input,
                    .form-input-code input {
                        border-radius: 5px;
                        border: 1px solid #E4E7ED;
                        height: 100%;
                        padding-left: 14px;
                    }

                    .form-input input:focus,
                    .form-input-code input:focus {
                        border: 1px solid #00C667;

                    }

                    .form-input {
                        height: 39px;

                        input {
                            box-sizing: border-box;
                            width: 100%;
                        }
                    }

                    .form-input-code {
                        height: 39px;
                        display: flex;
                        justify-content: space-between;

                        button {
                            margin-left: 10px;
                            background: #00C667;
                            font-size: 14px;
                            font-weight: 400;
                            color: #ffffff;
                        }

                        input {
                            box-sizing: border-box;
                        }
                    }

                    .err-message {
                        height: 24px;

                        .el-alert {
                            padding: 0;
                            padding-left: 10px;
                        }
                    }
                }
            }
        }
    }
}
.flie-ror-record {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  text-align: center;
  margin-top: 20px;
  a {
    margin: 0 10px;
    color: #666;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .container .mian-content {
        width: 90%;
        flex-direction: column;
    }
    .container .mian-content .right-box {
        display: none;
    }
    .container .mian-content .left-box {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
    }
    .flie-ror-record {
        width: 90%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        bottom: 10px;
        font-size: 12px;
    }
}
</style>
